import { render, staticRenderFns } from "./PageTemplateEvents.vue?vue&type=template&id=f48e805c&"
import script from "./PageTemplateEvents.vue?vue&type=script&lang=js&"
export * from "./PageTemplateEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f48e805c')) {
      api.createRecord('f48e805c', component.options)
    } else {
      api.reload('f48e805c', component.options)
    }
    module.hot.accept("./PageTemplateEvents.vue?vue&type=template&id=f48e805c&", function () {
      api.rerender('f48e805c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PageTemplateEvents.vue"
export default component.exports